define.alias("shared/helpers/html-safe", "calendar/helpers/html-safe");